export default __webpack_public_path__ + "static/summer_containers78-abe8ac29c104ccb1dcdef762eeed3403.webp";